import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'
import {
  Box,
  Button,
  Typography
} from '@mui/material';

import palette from "../../../theme/palette"
import CustomModal from '../../custom/CustomModal';
import { fNumber, scaleNumber } from '../../../utils/formatNumber';
import { isAuthorizedRole } from '../../../utils/authUtil';
import moment from 'moment';
import InnerCard from 'src/components/ui/InnerCard';
import { gridSize } from 'src/utils/constants';

export const OrderAllocationSummary = ({
  orderData,
  openModal,
  handleCloseModal,
  isBulk = false,
}) => {

  const [orderId, setOrderId] = useState(null);
  const [estimatedDeliveryTime, setEstimatedDeliveryTime] = useState(null);

  useEffect(() => {
    const edt = orderData?.delivery_scheduled_datetime || orderData?.scheduled_delivery_date || null;
    setOrderId(orderData?.suborder_id || orderData?.order_id);
    setEstimatedDeliveryTime(edt);

  }, [openModal, orderData]);

  return (
    <>
      {orderData && (
        <CustomModal
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          modalTitle={`Order ${orderId} Summary`}
        >
          {isBulk ? (
            <>
              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid size={{ ...gridSize }} key='company'>
                  <InnerCard type={"Comapany Name"} value={orderData?.company_name} />
                </Grid>
                <Grid size={{ ...gridSize }} key='fuel-type'>
                  <InnerCard type={"Product"} value={orderData?.fuel_type} />
                </Grid>
                <Grid size={{ ...gridSize }} key='created_by'>
                  <InnerCard type={"Created By"} value={fNumber(orderData?.created_by)} />
                </Grid>
              </Grid>

              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid size={{ ...gridSize }} key='volume'>
                  <InnerCard type={"volume"} value={fNumber(orderData?.volume)} />
                </Grid>
                <Grid size={{ ...gridSize }} key='delivery-date'>
                  <InnerCard type={"Delivery Date"} value={moment(estimatedDeliveryTime).format('YYYY/MM/DD - HH:mm:ss')} />
                </Grid>
                <Grid size={{ ...gridSize }} key='created_by'>
                  <InnerCard type={"Approved By"} value={fNumber(orderData?.approved_by)} />
                </Grid>
              </Grid>
            </>
          ) : (<>
            <Typography variant="inherit" sx={{ color: palette.grey[500] }}>{orderData?.transporter_name || ''}</Typography>

            <Grid container spacing={3} sx={{ mt: 2 }}>
              <Grid size={{ ...gridSize }} key='driver'>
                <InnerCard type={"Driver"} value={orderData?.driver_name} />
              </Grid>
              <Grid size={{ ...gridSize }} key='vehicle-truck'>
                <InnerCard type={"Vechile"} value={orderData?.vehicle_registration} />
              </Grid>
              {isAuthorizedRole(["CUSTOMS-L1"]) && (
                <Grid size={{ ...gridSize }} key='trailer'>
                  <InnerCard type={"Trailer"} value={orderData?.trailer1_registration} />
                </Grid>
              )}
              {isAuthorizedRole(["LOGISTICS-C2", "LOGISTICS-L2"]) && (
                <Grid size={{ ...gridSize }} key='volume'>
                  <InnerCard type={"volume"} value={fNumber(orderData?.volume)} />
                </Grid>
              )}
            </Grid>

            {isAuthorizedRole(["CUSTOMS-L1"]) && (
              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid size={{ ...gridSize }} key='volume'>
                  <InnerCard type={"volume"} value={fNumber(orderData?.volume)} />
                </Grid>
                <Grid size={{ ...gridSize }} key='Cost'>
                  <InnerCard type={"Cost"} value={scaleNumber(orderData?.cost)} />
                </Grid>
                <Grid size={{ ...gridSize }} key='Documents'>
                  <InnerCard type={"Documents"} value={`${orderData?.outstanding_documents || 0} outstanding documents `} />
                </Grid>
              </Grid>
            )}

            {isAuthorizedRole(["LOGISTICS-C2", "LOGISTICS-L2"]) && (
              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid size={{ ...gridSize }} key='eta'>
                  <InnerCard type={"ETA"} value={moment(estimatedDeliveryTime).format('YYYY/MM/DD - HH:mm:ss')} />
                </Grid>
                <Grid size={{ ...gridSize }} key='status'>
                  <InnerCard type={"Status"} value={`${orderData?.status || ''}`} />
                </Grid>
                <Grid size={{ ...gridSize }} key='remaining'>
                  <InnerCard type={"Remaining"} value={fNumber(orderData?.available_volume)} />
                </Grid>
              </Grid>
            )}
          </>)}

          <>
            <Box sx={{ display: 'flex', justifyContent: 'right' }}>
              <Button
                variant="outlined"
                sx={{ mt: 2, color: 'black', backgroundColor: palette.grey[200], border: palette.grey[200], }}
                onClick={handleCloseModal}
              >
                Close
              </Button>
            </Box>
          </>
        </CustomModal>
      )}
    </>
  )
}

OrderAllocationSummary.propTypes = {
  orderData: PropTypes.arrayOf(PropTypes.object).isRequired,
}
